import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams } from "ionic-angular";
import { ApiViewData, User, ViewDidEnter } from "../../app/app.interfaces";
import { PageTitleService } from "../../services/page-title.service";
import { EventService } from "../../services/event.service";
import { SearchService } from "../../services/search.service";
import { IonicHelper } from "../../helpers/ionic.helper";


@Component({
  selector: 'search',
  templateUrl: 'search.html'
})


export class Search implements ViewDidEnter {

	resultViewData: ApiViewData;
	
  @ViewChild('postListNav') postListNav: NavController;

  user: User;
  initialized: boolean = false;

  constructor(private nav: NavController,
							private navParams: NavParams,
							private eventService: EventService,
							private pageTitleService: PageTitleService,
							public searchService: SearchService,
              private ionic: IonicHelper
							) {        
  }

  ionViewDidEnter(): void {
    
    if(this.navParams.get('searchTerm')){
		  this.searchService.setSearchTerm(this.navParams.get('searchTerm'), 'navParams');
    }
		
		this.pageTitleService.setPageTitle('search', { searchTerm : this.searchService.searchTerm });
		
		this.initialized = true;
	}
	
	

  
}



// WEBPACK FOOTER //
// ./src/components/search/search.ts